import { Box, Typography } from "@mui/material";
import ReactHtmlParser from "@/src/utils/html-parser";
import type ArticleRelatedArticle from "@/src/_types/Article/article-related-article";

const ArticleRelatedArticles = ({
  relatedArticles,
  sourceRelatedArticles,
}: {
  relatedArticles: ArticleRelatedArticle[];
  sourceRelatedArticles: ArticleRelatedArticle[];
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 0.5,
      p: 1,
      my: 1,
      backgroundColor: "custom.newsprintRaised",
      border: "1px solid",
      borderColor: "custom.ruleHairline",
      borderRadius: 0,

      "& a": {
        textDecoration: "none",
        color: "custom.link",
        "&:hover": {
          color: "custom.linkHover",
        },
      },
    }}
  >
    {relatedArticles.length > 0 &&
      relatedArticles.map(
        (relatedArticle: ArticleRelatedArticle, index: number) => (
          <Box key={`related-article-${index}`}>
            <Typography
              component="span"
              sx={{
                mr: 0.25,
              }}
            ></Typography>
            {ReactHtmlParser(relatedArticle.text)}
          </Box>
        ),
      )}
    {sourceRelatedArticles.length > 0 &&
      sourceRelatedArticles.map(
        (sourceRelatedArticle: ArticleRelatedArticle, index: number) => (
          <Box key={`source-related-article-${index}`}>
            <Typography
              component="span"
              sx={{
                mr: 0.25,
              }}
            ></Typography>
            {ReactHtmlParser(sourceRelatedArticle.text)}
          </Box>
        ),
      )}
  </Box>
);

export default ArticleRelatedArticles;
